// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type EventDetailsForEditQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type EventDetailsForEditQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & EventDetailEditFragment
    )> }
  )> }
);

export type EventRelatedEntitiesQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type EventRelatedEntitiesQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id'>
      & { relatedCampaigns: Array<(
        { __typename?: 'CampaignModelAsAdminQueries' }
        & Pick<PrivateSchemaTypes.CampaignModelAsAdminQueries, 'id' | 'name' | 'actionsCount'>
      )> }
    )> }
  )> }
);

export type GetCalendarIntegrationsQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type GetCalendarIntegrationsQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminQueries, 'id'>
      & { calendars: (
        { __typename?: 'OrganisationCalendars' }
        & { msgraph?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'MSGraphCalendarConfig' }
          & Pick<PrivateSchemaTypes.MsGraphCalendarConfig, 'accountName'>
        )>, google?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'GoogleCalendarConfigPublic' }
          & Pick<PrivateSchemaTypes.GoogleCalendarConfigPublic, 'calendarId'>
        )> }
      ) }
    )> }
  )> }
);

export type EventPatchMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  data: PrivateSchemaTypes.EventModelInput;
  tags?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.Scalars['PositiveInt']> | PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type EventPatchMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id'>
      & { patch?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'EventModelAsAdmin' }
        & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'update_email_sent_at' | 'updated_at'>
        & EventPatchFragment
      )> }
    )> }
  )> }
);

export type PatchEventAndNotifyMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  emailIdentityId?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
  notifyInvitees?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['Boolean']>;
  notifyRSVPdInvitees?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['Boolean']>;
  data: PrivateSchemaTypes.EventModelInput;
  tags?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.Scalars['PositiveInt']> | PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type PatchEventAndNotifyMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id'>
      & { patch?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'EventModelAsAdmin' }
        & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'update_email_sent_at' | 'updated_at'>
        & EventPatchFragment
      )> }
    )> }
  )> }
);

export type CancelEventMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  sendCancellationEmail: PrivateSchemaTypes.Scalars['Boolean'];
  emailIdentityId?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type CancelEventMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id' | 'delete'>
    )> }
  )> }
);

export type SendEmailToAllEventInviteesMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  emailIdentityId?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type SendEmailToAllEventInviteesMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id'>
      & { sendUpdatedEmailToAllInvitees?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'EventModelAsAdmin' }
        & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'update_email_sent_at' | 'updated_at'>
      )> }
    )> }
  )> }
);

export type PublishEventAndUpdateCalendarsMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type PublishEventAndUpdateCalendarsMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id' | 'publish' | 'sendNewEventTo3dPartyCalendars'>
    )> }
  )> }
);

export type SendNewEventTo3dPartyCalendarsMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type SendNewEventTo3dPartyCalendarsMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id' | 'sendNewEventTo3dPartyCalendars'>
    )> }
  )> }
);

export type PublishEventMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type PublishEventMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id' | 'publish'>
    )> }
  )> }
);

export type EventPatchNoReturnedFieldsMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  data: PrivateSchemaTypes.EventModelInput;
}>;


export type EventPatchNoReturnedFieldsMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id'>
      & { patch?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'EventModelAsAdmin' }
        & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id'>
      )> }
    )> }
  )> }
);

export type EventDetailEditFragment = (
  { __typename?: 'EventModelAsAdmin' }
  & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id' | 'title' | 'location' | 'start_time' | 'end_time' | 'timezone' | 'description' | 'participants_limit' | 'update_email_sent_at' | 'updated_at' | 'is_open' | 'inviteesCount' | 'attendeesCount' | 'published_date' | 'allow_comments' | 'google_meet_uuid' | 'google_meet_id' | 'ms_teams_enabled' | 'ms_teams_url' | 'recurring_event_id'>
  & { tags: Array<(
    { __typename?: 'TagModel' }
    & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
  )>, author: (
    { __typename?: 'UserModelPublicBase' }
    & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name'>
  ), facilitator?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'UserModelPublicBase' }
    & Pick<PrivateSchemaTypes.UserModelPublicBase, 'display_name' | 'image_url' | 'id' | 'userIdentity'>
  )>, relatedCertifications: Array<(
    { __typename?: 'CertificationModelAsAdmin' }
    & Pick<PrivateSchemaTypes.CertificationModelAsAdmin, 'id' | 'name'>
    & { author?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModel' }
      & Pick<PrivateSchemaTypes.UserModel, 'id' | 'userIdentity'>
    )> }
  )>, recurringEvent?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'RecurringEventModelAsStudent' }
    & Pick<PrivateSchemaTypes.RecurringEventModelAsStudent, 'id'>
    & { recurrence?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventRecurrencePattern' }
      & Pick<PrivateSchemaTypes.EventRecurrencePattern, 'interval' | 'count' | 'byDay' | 'freq'>
    )> }
  )> }
);

export type EventPatchFragment = (
  { __typename?: 'EventModelAsAdmin' }
  & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id' | 'title' | 'location' | 'start_time' | 'end_time' | 'timezone' | 'description' | 'participants_limit' | 'is_open' | 'attendeesCount' | 'presentCount' | 'published_date' | 'allow_comments' | 'facilitator_id' | 'google_meet_uuid' | 'google_meet_id' | 'ms_teams_enabled' | 'ms_teams_url'>
  & { tags: Array<(
    { __typename?: 'TagModel' }
    & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
  )>, author: (
    { __typename?: 'UserModelPublicBase' }
    & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name'>
  ) }
);

export const EventDetailEditFragmentDoc = gql`
    fragment eventDetailEdit on EventModelAsAdmin {
  id
  title
  location
  start_time
  end_time
  timezone
  description
  participants_limit
  update_email_sent_at
  updated_at
  is_open
  inviteesCount
  attendeesCount
  published_date
  allow_comments
  tags {
    id
    name
  }
  author {
    id
    display_name
  }
  facilitator {
    display_name
    image_url
    id
    userIdentity
  }
  google_meet_uuid
  google_meet_id
  ms_teams_enabled
  ms_teams_url
  recurring_event_id
  relatedCertifications {
    id
    name
    author {
      id
      userIdentity
    }
  }
  recurringEvent {
    id
    recurrence {
      interval
      count
      byDay
      freq
    }
  }
}
    `;
export const EventPatchFragmentDoc = gql`
    fragment eventPatch on EventModelAsAdmin {
  id
  title
  location
  start_time
  end_time
  timezone
  description
  participants_limit
  is_open
  attendeesCount
  presentCount
  published_date
  allow_comments
  tags {
    id
    name
  }
  author {
    id
    display_name
  }
  facilitator_id
  google_meet_uuid
  google_meet_id
  ms_teams_enabled
  ms_teams_url
}
    `;
export const EventDetailsForEditDocument = gql`
    query eventDetailsForEdit($eventId: PositiveInt!) {
  admin {
    event(id: $eventId) {
      ...eventDetailEdit
    }
  }
}
    ${EventDetailEditFragmentDoc}`;

/**
 * __useEventDetailsForEditQuery__
 *
 * To run a query within a React component, call `useEventDetailsForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventDetailsForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventDetailsForEditQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventDetailsForEditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EventDetailsForEditQuery, EventDetailsForEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EventDetailsForEditQuery, EventDetailsForEditQueryVariables>(EventDetailsForEditDocument, options);
      }
export function useEventDetailsForEditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventDetailsForEditQuery, EventDetailsForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EventDetailsForEditQuery, EventDetailsForEditQueryVariables>(EventDetailsForEditDocument, options);
        }
export type EventDetailsForEditQueryHookResult = ReturnType<typeof useEventDetailsForEditQuery>;
export type EventDetailsForEditLazyQueryHookResult = ReturnType<typeof useEventDetailsForEditLazyQuery>;
export type EventDetailsForEditQueryResult = Apollo.QueryResult<EventDetailsForEditQuery, EventDetailsForEditQueryVariables>;
export const EventRelatedEntitiesDocument = gql`
    query eventRelatedEntities($eventId: PositiveInt!) {
  admin {
    event(id: $eventId) {
      id
      relatedCampaigns {
        id
        name
        actionsCount
      }
    }
  }
}
    `;

/**
 * __useEventRelatedEntitiesQuery__
 *
 * To run a query within a React component, call `useEventRelatedEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventRelatedEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventRelatedEntitiesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventRelatedEntitiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EventRelatedEntitiesQuery, EventRelatedEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EventRelatedEntitiesQuery, EventRelatedEntitiesQueryVariables>(EventRelatedEntitiesDocument, options);
      }
export function useEventRelatedEntitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventRelatedEntitiesQuery, EventRelatedEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EventRelatedEntitiesQuery, EventRelatedEntitiesQueryVariables>(EventRelatedEntitiesDocument, options);
        }
export type EventRelatedEntitiesQueryHookResult = ReturnType<typeof useEventRelatedEntitiesQuery>;
export type EventRelatedEntitiesLazyQueryHookResult = ReturnType<typeof useEventRelatedEntitiesLazyQuery>;
export type EventRelatedEntitiesQueryResult = Apollo.QueryResult<EventRelatedEntitiesQuery, EventRelatedEntitiesQueryVariables>;
export const GetCalendarIntegrationsDocument = gql`
    query getCalendarIntegrations {
  admin {
    organisation {
      id
      calendars {
        msgraph {
          accountName
        }
        google {
          calendarId
        }
      }
    }
  }
}
    `;

/**
 * __useGetCalendarIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetCalendarIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCalendarIntegrationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCalendarIntegrationsQuery, GetCalendarIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCalendarIntegrationsQuery, GetCalendarIntegrationsQueryVariables>(GetCalendarIntegrationsDocument, options);
      }
export function useGetCalendarIntegrationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCalendarIntegrationsQuery, GetCalendarIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCalendarIntegrationsQuery, GetCalendarIntegrationsQueryVariables>(GetCalendarIntegrationsDocument, options);
        }
export type GetCalendarIntegrationsQueryHookResult = ReturnType<typeof useGetCalendarIntegrationsQuery>;
export type GetCalendarIntegrationsLazyQueryHookResult = ReturnType<typeof useGetCalendarIntegrationsLazyQuery>;
export type GetCalendarIntegrationsQueryResult = Apollo.QueryResult<GetCalendarIntegrationsQuery, GetCalendarIntegrationsQueryVariables>;
export const EventPatchDocument = gql`
    mutation eventPatch($eventId: PositiveInt!, $data: EventModelInput!, $tags: [PositiveInt!]) {
  admin {
    event(id: $eventId) {
      id
      patch(data: $data, tags: $tags) {
        ...eventPatch
        update_email_sent_at
        updated_at
      }
    }
  }
}
    ${EventPatchFragmentDoc}`;
export type EventPatchMutationFn = Apollo.MutationFunction<EventPatchMutation, EventPatchMutationVariables>;

/**
 * __useEventPatchMutation__
 *
 * To run a mutation, you first call `useEventPatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventPatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventPatchMutation, { data, loading, error }] = useEventPatchMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      data: // value for 'data'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEventPatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EventPatchMutation, EventPatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EventPatchMutation, EventPatchMutationVariables>(EventPatchDocument, options);
      }
export type EventPatchMutationHookResult = ReturnType<typeof useEventPatchMutation>;
export type EventPatchMutationResult = Apollo.MutationResult<EventPatchMutation>;
export type EventPatchMutationOptions = Apollo.BaseMutationOptions<EventPatchMutation, EventPatchMutationVariables>;
export const PatchEventAndNotifyDocument = gql`
    mutation patchEventAndNotify($eventId: PositiveInt!, $emailIdentityId: PositiveInt, $notifyInvitees: Boolean, $notifyRSVPdInvitees: Boolean, $data: EventModelInput!, $tags: [PositiveInt!]) {
  admin {
    event(id: $eventId) {
      id
      patch(
        data: $data
        tags: $tags
        emailIdentityId: $emailIdentityId
        notifyRSVPdInvitees: $notifyRSVPdInvitees
        notifyAllInvitees: $notifyInvitees
      ) {
        ...eventPatch
        update_email_sent_at
        updated_at
      }
    }
  }
}
    ${EventPatchFragmentDoc}`;
export type PatchEventAndNotifyMutationFn = Apollo.MutationFunction<PatchEventAndNotifyMutation, PatchEventAndNotifyMutationVariables>;

/**
 * __usePatchEventAndNotifyMutation__
 *
 * To run a mutation, you first call `usePatchEventAndNotifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchEventAndNotifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchEventAndNotifyMutation, { data, loading, error }] = usePatchEventAndNotifyMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      emailIdentityId: // value for 'emailIdentityId'
 *      notifyInvitees: // value for 'notifyInvitees'
 *      notifyRSVPdInvitees: // value for 'notifyRSVPdInvitees'
 *      data: // value for 'data'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function usePatchEventAndNotifyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PatchEventAndNotifyMutation, PatchEventAndNotifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PatchEventAndNotifyMutation, PatchEventAndNotifyMutationVariables>(PatchEventAndNotifyDocument, options);
      }
export type PatchEventAndNotifyMutationHookResult = ReturnType<typeof usePatchEventAndNotifyMutation>;
export type PatchEventAndNotifyMutationResult = Apollo.MutationResult<PatchEventAndNotifyMutation>;
export type PatchEventAndNotifyMutationOptions = Apollo.BaseMutationOptions<PatchEventAndNotifyMutation, PatchEventAndNotifyMutationVariables>;
export const CancelEventDocument = gql`
    mutation cancelEvent($eventId: PositiveInt!, $sendCancellationEmail: Boolean!, $emailIdentityId: PositiveInt) {
  admin {
    event(id: $eventId) {
      id
      delete(
        sendCancellationEmail: $sendCancellationEmail
        emailIdentityId: $emailIdentityId
      )
    }
  }
}
    `;
export type CancelEventMutationFn = Apollo.MutationFunction<CancelEventMutation, CancelEventMutationVariables>;

/**
 * __useCancelEventMutation__
 *
 * To run a mutation, you first call `useCancelEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelEventMutation, { data, loading, error }] = useCancelEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      sendCancellationEmail: // value for 'sendCancellationEmail'
 *      emailIdentityId: // value for 'emailIdentityId'
 *   },
 * });
 */
export function useCancelEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelEventMutation, CancelEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelEventMutation, CancelEventMutationVariables>(CancelEventDocument, options);
      }
export type CancelEventMutationHookResult = ReturnType<typeof useCancelEventMutation>;
export type CancelEventMutationResult = Apollo.MutationResult<CancelEventMutation>;
export type CancelEventMutationOptions = Apollo.BaseMutationOptions<CancelEventMutation, CancelEventMutationVariables>;
export const SendEmailToAllEventInviteesDocument = gql`
    mutation sendEmailToAllEventInvitees($eventId: PositiveInt!, $emailIdentityId: PositiveInt) {
  admin {
    event(id: $eventId) {
      id
      sendUpdatedEmailToAllInvitees(emailIdentityId: $emailIdentityId) {
        update_email_sent_at
        updated_at
      }
    }
  }
}
    `;
export type SendEmailToAllEventInviteesMutationFn = Apollo.MutationFunction<SendEmailToAllEventInviteesMutation, SendEmailToAllEventInviteesMutationVariables>;

/**
 * __useSendEmailToAllEventInviteesMutation__
 *
 * To run a mutation, you first call `useSendEmailToAllEventInviteesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailToAllEventInviteesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailToAllEventInviteesMutation, { data, loading, error }] = useSendEmailToAllEventInviteesMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      emailIdentityId: // value for 'emailIdentityId'
 *   },
 * });
 */
export function useSendEmailToAllEventInviteesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendEmailToAllEventInviteesMutation, SendEmailToAllEventInviteesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendEmailToAllEventInviteesMutation, SendEmailToAllEventInviteesMutationVariables>(SendEmailToAllEventInviteesDocument, options);
      }
export type SendEmailToAllEventInviteesMutationHookResult = ReturnType<typeof useSendEmailToAllEventInviteesMutation>;
export type SendEmailToAllEventInviteesMutationResult = Apollo.MutationResult<SendEmailToAllEventInviteesMutation>;
export type SendEmailToAllEventInviteesMutationOptions = Apollo.BaseMutationOptions<SendEmailToAllEventInviteesMutation, SendEmailToAllEventInviteesMutationVariables>;
export const PublishEventAndUpdateCalendarsDocument = gql`
    mutation publishEventAndUpdateCalendars($id: PositiveInt!) {
  admin {
    event(id: $id) {
      id
      publish
      sendNewEventTo3dPartyCalendars
    }
  }
}
    `;
export type PublishEventAndUpdateCalendarsMutationFn = Apollo.MutationFunction<PublishEventAndUpdateCalendarsMutation, PublishEventAndUpdateCalendarsMutationVariables>;

/**
 * __usePublishEventAndUpdateCalendarsMutation__
 *
 * To run a mutation, you first call `usePublishEventAndUpdateCalendarsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishEventAndUpdateCalendarsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishEventAndUpdateCalendarsMutation, { data, loading, error }] = usePublishEventAndUpdateCalendarsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishEventAndUpdateCalendarsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishEventAndUpdateCalendarsMutation, PublishEventAndUpdateCalendarsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PublishEventAndUpdateCalendarsMutation, PublishEventAndUpdateCalendarsMutationVariables>(PublishEventAndUpdateCalendarsDocument, options);
      }
export type PublishEventAndUpdateCalendarsMutationHookResult = ReturnType<typeof usePublishEventAndUpdateCalendarsMutation>;
export type PublishEventAndUpdateCalendarsMutationResult = Apollo.MutationResult<PublishEventAndUpdateCalendarsMutation>;
export type PublishEventAndUpdateCalendarsMutationOptions = Apollo.BaseMutationOptions<PublishEventAndUpdateCalendarsMutation, PublishEventAndUpdateCalendarsMutationVariables>;
export const SendNewEventTo3dPartyCalendarsDocument = gql`
    mutation sendNewEventTo3dPartyCalendars($id: PositiveInt!) {
  admin {
    event(id: $id) {
      id
      sendNewEventTo3dPartyCalendars
    }
  }
}
    `;
export type SendNewEventTo3dPartyCalendarsMutationFn = Apollo.MutationFunction<SendNewEventTo3dPartyCalendarsMutation, SendNewEventTo3dPartyCalendarsMutationVariables>;

/**
 * __useSendNewEventTo3dPartyCalendarsMutation__
 *
 * To run a mutation, you first call `useSendNewEventTo3dPartyCalendarsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNewEventTo3dPartyCalendarsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNewEventTo3dPartyCalendarsMutation, { data, loading, error }] = useSendNewEventTo3dPartyCalendarsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendNewEventTo3dPartyCalendarsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendNewEventTo3dPartyCalendarsMutation, SendNewEventTo3dPartyCalendarsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendNewEventTo3dPartyCalendarsMutation, SendNewEventTo3dPartyCalendarsMutationVariables>(SendNewEventTo3dPartyCalendarsDocument, options);
      }
export type SendNewEventTo3dPartyCalendarsMutationHookResult = ReturnType<typeof useSendNewEventTo3dPartyCalendarsMutation>;
export type SendNewEventTo3dPartyCalendarsMutationResult = Apollo.MutationResult<SendNewEventTo3dPartyCalendarsMutation>;
export type SendNewEventTo3dPartyCalendarsMutationOptions = Apollo.BaseMutationOptions<SendNewEventTo3dPartyCalendarsMutation, SendNewEventTo3dPartyCalendarsMutationVariables>;
export const PublishEventDocument = gql`
    mutation publishEvent($id: PositiveInt!) {
  admin {
    event(id: $id) {
      id
      publish
    }
  }
}
    `;
export type PublishEventMutationFn = Apollo.MutationFunction<PublishEventMutation, PublishEventMutationVariables>;

/**
 * __usePublishEventMutation__
 *
 * To run a mutation, you first call `usePublishEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishEventMutation, { data, loading, error }] = usePublishEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishEventMutation, PublishEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PublishEventMutation, PublishEventMutationVariables>(PublishEventDocument, options);
      }
export type PublishEventMutationHookResult = ReturnType<typeof usePublishEventMutation>;
export type PublishEventMutationResult = Apollo.MutationResult<PublishEventMutation>;
export type PublishEventMutationOptions = Apollo.BaseMutationOptions<PublishEventMutation, PublishEventMutationVariables>;
export const EventPatchNoReturnedFieldsDocument = gql`
    mutation eventPatchNoReturnedFields($eventId: PositiveInt!, $data: EventModelInput!) {
  admin {
    event(id: $eventId) {
      id
      patch(data: $data) {
        id
      }
    }
  }
}
    `;
export type EventPatchNoReturnedFieldsMutationFn = Apollo.MutationFunction<EventPatchNoReturnedFieldsMutation, EventPatchNoReturnedFieldsMutationVariables>;

/**
 * __useEventPatchNoReturnedFieldsMutation__
 *
 * To run a mutation, you first call `useEventPatchNoReturnedFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventPatchNoReturnedFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventPatchNoReturnedFieldsMutation, { data, loading, error }] = useEventPatchNoReturnedFieldsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEventPatchNoReturnedFieldsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EventPatchNoReturnedFieldsMutation, EventPatchNoReturnedFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EventPatchNoReturnedFieldsMutation, EventPatchNoReturnedFieldsMutationVariables>(EventPatchNoReturnedFieldsDocument, options);
      }
export type EventPatchNoReturnedFieldsMutationHookResult = ReturnType<typeof useEventPatchNoReturnedFieldsMutation>;
export type EventPatchNoReturnedFieldsMutationResult = Apollo.MutationResult<EventPatchNoReturnedFieldsMutation>;
export type EventPatchNoReturnedFieldsMutationOptions = Apollo.BaseMutationOptions<EventPatchNoReturnedFieldsMutation, EventPatchNoReturnedFieldsMutationVariables>;